export const TradingHouseMapper: { [product: string]: string } = {
  gtf: 'Day Trade Learning Center',
  greenchart: 'GreenChart',
}
